// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"329":"datepicker","401":"editEvent","966":"login"}[chunkId] + "." + {"329":"a25430929ca6ccfed239","401":"12213e18daa4dbbaf143","966":"335a9ea9ae2b4816a4fc"}[chunkId] + ".bundle.js";
};